import { nameGroups } from "@/mocks/homeData";
import type { NameGroup } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function NameDirectory() {
  return (
    <section id="names" className="w-full bg-background-100 px-4 py-20 md:px-8 md:py-28">
      <SectionHeading
        kicker="黑料网红名单"
        title="名单按题材分组归档，一栏一位"
        desc="黑料网红名单只做资料整理与上下文补充，按题材分成三组，方便按兴趣集中浏览。
          同一个名字可能同时出现在多期内容里，条目会随更新不断增补。"
      />

      <div className="mt-12 grid grid-cols-1 gap-6 md:mt-16 md:grid-cols-3">
        {nameGroups.map((group: NameGroup) => (
          <div
            key={group.category}
            className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
          >
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${group.icon} text-lg`} />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">
                {group.category}
              </h3>
            </div>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-600">
              {group.desc}
            </p>

            <ul className="mt-6 flex flex-col">
              {group.items.map((entry) => (
                <li
                  key={entry.name}
                  className="border-t border-background-200 py-4 first:border-t-0 first:pt-0"
                >
                  <div className="flex items-center justify-between gap-3">
                    <span className="font-heading text-sm font-bold text-foreground-900">
                      {entry.name}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-400">
                      <i className="ri-arrow-right-up-line text-base" />
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">
                    {entry.note}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p className="mt-8 font-label text-xs leading-relaxed text-foreground-500">
        注：名单为话题整理，不代表对任何个人的评价；如需补充上下文，可在下方热评区留言。
      </p>
    </section>
  );
}